<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title">
            <ng-container i18n>Review Insights</ng-container>
          </h6>
          <app-rental-name [rentalId]="data.rentalId" class="text-semi-bold"></app-rental-name>
        </div>
        <div class="flex-fill"></div>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="container-box">
        <app-rental-review-insights
          [rentalId]="data.rentalId"
          [data]="data.rentalAverageOverallRating"
        ></app-rental-review-insights>
      </div>
    </div>
  </div>
</div>
